import { Box, Grid, MenuItem, Select, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTheme } from '@mui/material/styles';
import CustomButton from "../../components/CustomButton";
import { makeStyles } from '@mui/styles';
import { CheckBoxOutlineBlank, CheckBoxOutlineBlankOutlined, CheckBoxOutlined, CheckCircleOutline, CheckCircleOutlineRounded, CheckCircleOutlined, CheckCircleRounded, ReceiptLongOutlined, ReceiptOutlined } from "@mui/icons-material";
import { portalCfg } from "../../config";
import StepHeader from "../../components/StepHeader";
import { cached } from "../../utils/cache";
import { STEPS_REGISTER } from "../../utils/util";
import { getPackageInfo, isVumaPackage, isVumaReachPackage } from "../../utils/commons";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
    select_container: {
        width: '100%',
        marginTop: theme.spacing(2),
        border: '2px solid ' + theme.palette.primary.main,
        [theme.breakpoints.down('md')]: {
            width: '100%',
        },
    },
    select_input: {
        border: 0,
    },
    option_payment: {
        width: '100%',
        cursor: 'pointer',
        padding: theme.spacing(2, 4),
        margin: theme.spacing(2, 0),
        borderRadius: theme.spacing(2),
        [theme.breakpoints.down('md')]: {
            width: '100%',
            padding: theme.spacing(1),
        },
    }
}))

export default function PaymentSetupView(props) {
    const { palette, spacing } = useTheme();
    const billingInfoCached = cached.getBillingInfo();
    const [billingDay, setBillingDay] = useState(null);
    const [optionPayment, setOptionPayment] = useState('PAYGATE');
    const [showSelectDay, setShowSelectDay] = useState(false);
    const [isSaveCard, setIsSaveCard] = useState(true);
    const package_info = getPackageInfo();
    const dates = [
        {
            label: '1',
            value: '1',
        },
        {
            label: '16',
            value: '16',
        },
        {
            label: '21',
            value: '21',
        },
        {
            label: '26',
            value: '26',
        },
    ]
    const classes = useStyles();
    const { t } = useTranslation();

    useEffect(() => {
        let _showSelectDay = false;
        let _billingDate = null;
        if (isVumaReachPackage(package_info?.product_type)) {
            if (billingInfoCached?.is_recurring) {
                _showSelectDay = true;
                _billingDate = '1';
            } else {
                _showSelectDay = false;
                _billingDate = null;
            }
        } else {
            _showSelectDay = true;
            _billingDate = '1';
        }
        setShowSelectDay(_showSelectDay);
        setBillingDay(_billingDate);
    },[])

    useEffect(() => {
        if (optionPayment == 'PAYGATE') setIsSaveCard(true);
    },[optionPayment])

    useEffect(() => {
        if (package_info && isVumaReachPackage(package_info?.product_type)) {
            setIsSaveCard(false);
        }
    },[package_info])

    const onContinue = () => {
        cached.setBillinginfo({
            is_recurring: billingInfoCached?.is_recurring,
            date: billingDay,
            option_payment: optionPayment,
            save_card: optionPayment == 'PAYGATE' && isSaveCard ? true: false,
        });
        props.stepsControl.goToStepByName(STEPS_REGISTER.place_order)
    }

    const onGoBack = () => {
        if (isVumaReachPackage(package_info?.product_type)) {
            props.stepsControl.goToStepByName(STEPS_REGISTER.payment)
        } else {
            props.stepsControl.goToStepByName(STEPS_REGISTER.rica_verification)
        }
    }
    console.log("billingDay: ", billingDay)
    return (
        <Grid item xs={12} paddingX={4}>
            <Grid item xs={12} bgcolor={palette.common.white} borderRadius={spacing(3)}>
                {showSelectDay && <Grid item xs={12} my={2}>
                    <StepHeader
                        title={t('choose_your_billing_date')}
                        palette={palette}
                        onBack={() => onGoBack()}
                    />
                    {/* <Typography variant="h1" color={palette.primary.main}></Typography> */}
                    <Typography variant="subtitle1">{t('choose_your_billing_date_desc')}</Typography>
                    <Select
                        id="choose-billing-date"
                        fullWidth
                        onChange={(e) => {
                            console.log("onchange e===", e)
                            setBillingDay(e.target.value);
                        }}
                        size="small"
                        className={classes.select_container}
                        inputProps={{ className: classes.select_input }}
                        sx={{
                            "& .MuiOutlinedInput-notchedOutline": {
                                border: 'none'
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: palette.primary.main,
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                borderColor: palette.primary.main,
                            },
                        }}
                        value={billingDay}
                    >
                        {dates && dates.map((item, index) => {
                            return (
                                <MenuItem key={index} value={item.value}>{item.label}</MenuItem>
                            )
                        })}
                    </Select>
                </Grid>}

                <Grid item xs={12} py={showSelectDay ? 0 : 2}>
                    {!showSelectDay ? 
                    <StepHeader
                        title={t('how_would_you_like_to_pay')}
                        palette={palette}
                        onBack={() => onGoBack()}
                    /> : <Typography variant="h5" color={palette.primary.main} fontWeight={'bold'}>{t('how_would_you_like_to_pay')}</Typography>}
                    
                    <Typography variant="subtitle1">{t('pay_manually_easypay')}</Typography>
                    <Grid item xs={12} border={optionPayment == 'PAYGATE' ? '2px solid' : 'none'}
                        borderColor={optionPayment == 'PAYGATE' ? palette.primary.main : undefined}
                        onClick={() => setOptionPayment('PAYGATE')}
                        className={classes.option_payment}
                    >
                        <Grid item xs={12} container spacing={1} alignItems={'center'}>
                            <Grid item xs={2} container alignItems={'center'} spacing={2} justifyContent={'center'}>
                                <Grid item>
                                    <img src={`${portalCfg.publicPath}/images/visa.png`} height={30} />
                                </Grid>
                                <Grid item>
                                    <img src={`${portalCfg.publicPath}/images/mastercard.png`} height={30} />
                                </Grid>
                            </Grid>
                            <Grid item xs={8}>
                                <Typography variant="h6">PayGate</Typography>
                                <Typography variant="subtitle2">{t('pay_using_secure_payment_link')}</Typography>
                                {!isVumaReachPackage(package_info?.product_type) && <Grid item xs={12} container style={{ cursor: 'pointer' }} alignItems={'center'} spacing={1} onClick={(event) => { event.preventDefault(); setIsSaveCard(!isSaveCard)}}>
                                    <Grid item>
                                        {isSaveCard ? <CheckBoxOutlined style={{ color: palette.primary.main }}/> : <CheckBoxOutlineBlank />}
                                    </Grid>
                                    <Grid item>
                                        <Typography>{t('save_card_automatic')}</Typography>
                                        <Typography variant="body1" color={palette.text.disabled}>{t('change_anytime')}</Typography>
                                    </Grid>
                                </Grid>}
                            </Grid>
                            <Grid item xs={2} container justifyContent={'flex-end'}>
                                {optionPayment == 'PAYGATE' ? <CheckCircleRounded style={{ color: palette.primary.main }} /> : <CheckCircleOutline />}
                            </Grid>
                        </Grid>
                    </Grid>
                    {document._portalConfig.useEasyPay && <Grid item xs={12} border={optionPayment == 'EASYPAY' ? '2px solid' : 'none'}
                        borderColor={optionPayment == 'EASYPAY' ? palette.primary.main : undefined}
                        onClick={() => setOptionPayment('EASYPAY')}
                        className={classes.option_payment}
                    >
                        <Grid item xs={12} container spacing={1} alignItems={'center'}>
                            <Grid item xs={2} container alignItems={'center'} spacing={2} justifyContent={'center'}>
                                <ReceiptOutlined style={{ fontSize: '40px' }} />
                            </Grid>
                            <Grid item xs={8}>
                                <Typography variant="h6">EasyPay</Typography>
                                <Typography variant="subtitle2">{t('pay_at_easypay_kiosk')}</Typography>
                                <Typography variant="subtitle2">{t('pay_using_secure_payment_link')}</Typography>
                            </Grid>
                            <Grid item xs={2} container justifyContent={'flex-end'}>
                                {optionPayment == 'EASYPAY' ? <CheckCircleRounded style={{ color: palette.primary.main }} /> : <CheckCircleOutlined />}
                            </Grid>
                        </Grid>
                    </Grid>}
                </Grid>

                <Grid item xs={12} my={2} mt={4} container justifyContent={'center'}>
                    <CustomButton variant={'contained'} onClick={() => onContinue()}>{t('btn_continue_order_review')}</CustomButton>
                </Grid>
            </Grid>
        </Grid>
    )
}